export default {
  payment: "Payment",
  paymentMethods: "Payment methods",
  to: "to",
  changeLanguage: "Cambiar el idioma",
  checkByPhoto: "Check by photo",
  replace: "Replace",
  pleaseConfirmCheckAmount: "Please confirm check amount is equal to {amount} and submit",
  confirmCheckAmountAndSubmit: "Confirm {amount} & submit",
  submittedSuccessfully: "Submitted successully",
  // Pay by card
  payWithCard: "Credit Card",
  payWithAch: "Bank Transfer",
  fillInCardDetails: "Fill in card details",
  pleaseSignHere: "Please sign here",
  pleaseSignHereAutoSubmit: "Please sign here (will submit the form)",
  clearSignature: "Clear",
  noTip: "No tip",
  agreePayAboveAmount: "I agree to pay the above amount",
  agreePayAboveAmountFirst: "I agree to the",
  agreePayAboveAmountUrl: "company policy",
  agreePayAboveAmountLast: "and to pay the above amount, which is non-refundable",
  grossAmount: "Gross amount",
  nonCashAdj: "Non-cash adj",
  cashCheckPrice: "Cash/Check price",
  pay: "Pay",
  processing: "Processing...",
  loading: "Loading...",
  couldNotProcess: "You can not process a payment for this order. Contact support",
  noPaymentMethod: "Please reach out to the merchant. No active payment methods available",
  buyNowPayLaterButton: "Buy now pay later (Klarna)",
  withTipAmount: "Amount with tip",
  firstName: "First name",
  lastName: "Last name",
  routing: "Routing",
  accountNumber: "Account number",
  // Zelle Pay
  payByBankApp: "Bank App",
  sendMoney: "Send Money",
  withBankAppTo: "with Bank App to:",
  at: "ID: ",
  invoice: "Invoice:",
  amount: "Amount:",
  instructionStep1: "1. Copy ID and paste/enter in your Bank app",
  instructionStep2: "3. Copy amount and paste in your Bank app",
  instructionStep3WithInvoice: "4. Copy invoice # and paste in memo field",
  idCopied: "ID copied to clipboard",
  displayNameCopied: "Company name copied to clipboard",
  invoiceCopied: "Invoice copied to clipboard",
  amountCopied: "Amount copied to clipboard",
  instructionStepDisplayName: "2. Copy and paste Company name"
}
